<section>
    <ins-passport-container></ins-passport-container>
</section>

<section id="zelf-regelen" class="section">
    <ins-insurance-control-container></ins-insurance-control-container>
</section>

<section id="mijn-verzekeringen-section" *ngIf="isBrowser && !loading; else skeleton">
    <wuc-rack gridGap="large">
        <h2>Mijn verzekeringen</h2>
        <p *ngIf="purchasedProducts.length === 0">
            Oei, wat is het hier wit! Deze pagina is zo leeg, omdat u op dit moment geen verzekering(en) bij ons heeft
            lopen. Maar daar kan natuurlijk zo verandering in komen. Maak nu een vrijblijvende premieberekening en wie
            weet staat het hier dan binnenkort weer gezellig vol.
        </p>
        <ins-insurance-list
            class="insurance"
            *ngFor="let purchasedProduct of purchasedProducts"
            [purchasedProduct]="purchasedProduct"
            [relation]="relation"
        ></ins-insurance-list>
        <div class="insurance-total" *ngIf="totalPrice > 0">
            <span class="insurance-total__title">Totaal</span>
            <wuc-price [price]="totalPrice" size="l"></wuc-price>
            <p>per maand, o.b.v. de lopende verzekeringen</p>
        </div>
    </wuc-rack>
</section>

<ng-template #skeleton>
    <div class="insurance-skeleton">
        <div class="insurance-skeleton__icon skeleton-loader">
            <span class="skeleton-loader__icon"></span>
        </div>
        <div class="insurance-skeleton__info">
            <div class="insurance-skeleton__title">
                <div class="skeleton-loader__line insurance-skeleton__no-float"></div>
            </div>
            <div class="insurance-skeleton__left">
                <div class="skeleton-loader__line skeleton-loader__line--half insurance-skeleton__no-float"></div>
                <div class="skeleton-loader__line skeleton-loader__line--half insurance-skeleton__no-float"></div>
                <div class="skeleton-loader__line skeleton-loader__line--half insurance-skeleton__no-float"></div>
                <div class="skeleton-loader__line skeleton-loader__line--half insurance-skeleton__no-float"></div>
            </div>
            <div class="insurance-skeleton__well">
                <div class="well well--speech">
                    <div
                        class="skeleton-loader__line skeleton-loader__line--half insurance-skeleton__no-float insurance-skeleton__first"
                    ></div>
                    <div class="skeleton-loader__line skeleton-loader__line--half insurance-skeleton__no-float"></div>
                    <div class="skeleton-loader__line skeleton-loader__line--half insurance-skeleton__no-float"></div>
                </div>
            </div>
            <div class="insurance-skeleton__detail">
                <div class="insurance-skeleton__btn insurance-skeleton__btn--first">
                    <div class="skeleton-loader__line insurance-skeleton__no-float"></div>
                </div>
                <div class="insurance-skeleton__btn">
                    <div class="skeleton-loader__line insurance-skeleton__no-float"></div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
